import { render, staticRenderFns } from "./blocSelect.vue?vue&type=template&id=2eee709d&"
import script from "./blocSelect.vue?vue&type=script&lang=js&"
export * from "./blocSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports